import { render, staticRenderFns } from "./FallRisk.vue?vue&type=template&id=b40ef8f6&scoped=true"
import script from "./FallRisk.vue?vue&type=script&lang=js"
export * from "./FallRisk.vue?vue&type=script&lang=js"
import style0 from "./FallRisk.vue?vue&type=style&index=0&id=b40ef8f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40ef8f6",
  null
  
)

export default component.exports